import { Divider, Text, TextFading } from '@yes.technology/react-toolkit'
import { Field, FieldsRow, ValueContainer } from './TaskObjectCard.styles'

type TaskFieldProps = {
  value: string
  label?: string
}

export type TaskFieldsRowProps = {
  firstField: TaskFieldProps
  secondField?: TaskFieldProps
  gridTemplate?: string
}

const TaskFieldsRow = ({
  firstField,
  secondField,
  gridTemplate = 'repeat(2, 1fr)'
}: TaskFieldsRowProps) => {
  return (
    <FieldsRow $gridTemplate={gridTemplate}>
      <Field>
        <Text variant='content-emphasis-02'>{firstField?.label}</Text>
        <Divider heightClass='small' color='gray' />
        <ValueContainer>
          <TextFading>{firstField?.value}</TextFading>
        </ValueContainer>
      </Field>
      {secondField && (
        <Field>
          <Text variant='content-emphasis-02'>{secondField?.label}</Text>
          <Divider heightClass='small' color='gray' />
          <ValueContainer>{secondField?.value}</ValueContainer>
        </Field>
      )}
    </FieldsRow>
  )
}

export default TaskFieldsRow
